import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=029b654e&scoped=true&"
import script from "./order-summary.vue?vue&type=script&lang=js&"
export * from "./order-summary.vue?vue&type=script&lang=js&"
import style0 from "./order-summary.vue?vue&type=style&index=0&id=029b654e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029b654e",
  null
  
)

export default component.exports